module.exports = __webpack_public_path__ + "img/contact-left.af20b21e.png";